module.exports = __webpack_public_path__ + "static/media/blog.eee3625c.svg";